"use client";
import { useState } from "react";
import Link from "next/link";

export default function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setMessage(null);
    setLoading(true);
    const res = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password, remember }),
    });
    setLoading(false);
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      setMessage(typeof data?.error === "string" ? data.error : "Login failed.");
      return;
    }
    if (data?.must_reset) {
      window.location.href = "/change-password";
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const next = params.get("next");
    if (next && next.startsWith("/") && !next.startsWith("//")) {
      window.location.href = next;
      return;
    }
    if (data?.role === "admin") {
      window.location.href = "/admin";
      return;
    }
    window.location.href = "/";
  }

  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: "70vh" }}>
      <form className="card" onSubmit={submit} style={{ width: 360, display: "grid", gap: 12 }}>
        <h3 style={{ margin: 0 }}>Sign in</h3>
        <input
          className="input"
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <input
          className="input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
        <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13 }}>
          <input type="checkbox" checked={remember} onChange={e => setRemember(e.target.checked)} />
          Remember me
        </label>
        {message ? <div style={{ color: "var(--color-danger)", fontSize: 13 }}>{message}</div> : null}
        <button className="btn" disabled={loading}>{loading ? "Signing in…" : "Sign in"}</button>
        <div style={{ fontSize: 12, textAlign: "center" }}>
          <Link href="/forgot-password">Forgot password?</Link>
        </div>
      </form>
    </div>
  );
}
